import { render, staticRenderFns } from "./reportsData.vue?vue&type=template&id=67aeef34&scoped=true&"
import script from "./reportsData.vue?vue&type=script&lang=js&"
export * from "./reportsData.vue?vue&type=script&lang=js&"
import style0 from "./reportsData.vue?vue&type=style&index=0&id=67aeef34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aeef34",
  null
  
)

export default component.exports